<template>
  <generic-container
    v-bind:show_plus="true"
    icon="calendar"
    :title="$t('periods')"
    v-on:add="add"
  >
    <table class="ui compact celled striped definition table">
      <thead class="full-width">
        <tr>
          <th>{{ $t("active") }}</th>
          <th>{{ $t("name") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(period, index) in setup.std_periods" v-bind:key="index">
          <td class="collapsing">
            <div
              class="ui fitted slider checkbox"
              ref="activate_toggle"
              :data-period="period.period_id"
            >
              <input
                type="checkbox"
                :checked="period.is_active ? true : false"
              />
              <label></label>
            </div>
          </td>
          <td>{{ period.name }}</td>
          <td>
            <!-- <div class="ui basic buttons"> -->
            <div
              class="ui mini basic right floated button"
              @click="set_up(period)"
            >
              <i class="settings icon"></i>
              {{ $t("configure") }}
            </div>
            <div
              class="ui mini basic right floated button"
              @click="remove(period, index)"
            >
              <i class="red trash icon"></i>
              {{ $t("delete") }}
            </div>
            <!-- </div> -->
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <div class="ui three cards" v-if="setup && setup.std_periods">
      <div class="card" v-for="(period, index) in setup.std_periods" v-bind:key="index">
        <div class="content">
          <div class="header">{{ period.name }}</div>
          <div class="description">{{ period.name }}</div>
        </div>
        <div class="ui bottom attached basic buttons">
          <div class="ui button" @click="set_up(period)">
            <i class="settings icon"></i>
            {{ $t("configure") }}
          </div>
          <div class="ui button" @click="remove(period, index)">
            <i class="red trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
      </div>
    </div>-->
    <template v-for="(mdl, index) in period_modals">
      <component
        :is="mdl"
        :key="index"
        :period_uuid="selected_period.uuid"
        @updated="finish"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify } from "@/utils";
import PeriodModal from "../period_modal/PeriodModalIndex";

export default {
  name: "StudentConfigurationModalPeriods",
  components: {
    GenericContainer,
  },
  props: {
    setup: Object,
  },
  data() {
    return {
      period_modals: [],
      selected_period: {},
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.$alertify.prompt(this.$t("enter period name"), "", function(
        element,
        value,
      ) {
        local_api(vm, "post", "/student_configuration/do-create-period", {
          n: value,
        })
          .then((l) => {
            if (vm.setup && !vm.setup.std_periods) vm.setup.std_periods = [];
            vm.setup.std_periods.push(l);
          })
          .catch((err) => {
            vm.$alertify.error(stringify(err));
          });
      });
    },
    remove(period, index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove period?"), function() {
        local_api(vm, "post", "/student_configuration/do-remove-period", {
          u: period.uuid,
        })
          .then(() => {
            vm.setup.std_periods.splice(index, 1);
          })
          .catch((err) => {
            vm.$alertify.error(stringify(err));
          });
      });
    },
    set_up(period) {
      this.selected_period = period;
      this.period_modals.push(PeriodModal);
    },
    finish(data) {
      let trgt = this.setup.std_periods.find((n) => n.uuid == data.uuid);
      if (trgt) {
        trgt.name = data.name;
      }
    },
  },
  mounted() {
    let vm = this;
    setTimeout(() => {
      window.jQuery(vm.$refs.activate_toggle).checkbox({
        onChange() {
          let $this = window.jQuery(this);
          let parent = $this.parent();
          let isChecked = parent.checkbox("is checked");
          let period_id = parent.data("period");
          if (isChecked) {
            vm.setup.std_periods.forEach((p) => {
              if (p.period_id != period_id) p.is_active = false;
              else p.is_active = true;
            });

            local_api(
              vm,
              "post",
              "/student_configuration/do-set-active-period",
              {
                u: period_id,
              },
            )
              .then(() => {})
              .catch((err) => {
                vm.$alertify.error(stringify(err));
              });
          }
        },
      });
    }, 2000);
  },
};
</script>
